import { render, staticRenderFns } from "./EventsGrid.vue?vue&type=template&id=7cb990b9"
import script from "./EventsGrid.vue?vue&type=script&lang=js"
export * from "./EventsGrid.vue?vue&type=script&lang=js"
import style0 from "./EventsGrid.vue?vue&type=style&index=0&id=7cb990b9&prod&lang=css"
import style1 from "./EventsGrid.vue?vue&type=style&index=1&id=7cb990b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports